import { render, staticRenderFns } from "./add-scan-product-modal.vue?vue&type=template&id=5b3f4922&scoped=true&"
import script from "./add-scan-product-modal.vue?vue&type=script&lang=js&"
export * from "./add-scan-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-scan-product-modal.vue?vue&type=style&index=0&id=5b3f4922&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3f4922",
  null
  
)

export default component.exports